export default {"src":"/_next/static/media/logo.087f5d59.svg","height":24,"width":124,"blurWidth":0,"blurHeight":0};